export class menuDB {
    static data = [
        {
            name: "Product Menu",
            status: "<i class=\"fa fa-circle font-success f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
        {
            name: "Category Menu",
            status: "<i class=\"fa fa-circle font-warning f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
        {
            name: "Subcategory Menu",
            status: "<i class=\"fa fa-circle font-success f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
        {
            name: "Sales Menu",
            status: "<i class=\"fa fa-circle font-danger f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
        {
            name: "Vendor Menu",
            status: "<i class=\"fa fa-circle font-success f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
        {
            name: "Category Menu",
            status: "<i class=\"fa fa-circle font-warning f-12\"></i>",
            "created on": "2018-04-18T00:00:00",
        },
    ]
}
